import { render, staticRenderFns } from "./AddCarrier.vue?vue&type=template&id=19292665&"
import script from "./AddCarrier.vue?vue&type=script&lang=js&"
export * from "./AddCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports